var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column full-height black"},[_c('div',{staticClass:"logs-section"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.logViewerUrl,"allow":"clipboard-write;clipboard-read;display-capture;"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }